import React from 'react';
import { ReactComponent as IconMoney } from '../../../assets/icons/icon-cash.svg';
import { ReactComponent as IconParcel } from '../../../assets/icons/icon-parcel.svg';
import { ReactComponent as IconChecklist } from '../../../assets/icons/icon-checklist-rounded-full.svg';

const NotifAll = () => {
  return (
    <>
      {/* Start Item Notif */}
      <div className="flex bg-line-orange-100 px-6 py-4 flex-no-wrap cursor-pointer">
        <div className="flex rounded-full p-2 h-12 w-24 bg-basic-orange-16% items-center justify-center">
          <IconMoney className="h-6 w-6" />
        </div>
        <div className="flex flex-col mx-4 flex-grow">
          <div className="flex w-full justify-between mb-2">
            <h5 className="text-font-gray font-semibold">
              Konfirmasi Pembayaran
            </h5>
            <p className="text-sm opacity-50 text-font-gray">7:40</p>
          </div>
          <p className="text-sm text-font-gray-light">
            Pesanan <span className="text-basic-orange">24089794727000824</span>{' '}
            menunggu pembayaran. silahkan sesuaikan nominal pesanannya
          </p>
        </div>
      </div>
      {/* End Item  Notif */}
      {/* Start Item Notif */}
      <div className="flex bg-line-orange-100 px-6 py-4 flex-no-wrap cursor-pointer items-start">
        <div className="flex rounded-full p-2 h-12 w-24 bg-basic-orange-16% items-center justify-center">
          <IconParcel className="h-6 w-6" />
        </div>
        <div className="flex flex-col mx-4 flex-grow">
          <div className="flex w-full justify-between mb-2">
            <h5 className="text-font-gray font-semibold">Pesanan Sampai </h5>
            <p className="text-sm opacity-50 text-font-gray">8:40 </p>
          </div>
          <p className="text-sm text-font-gray-light">
            Pesanan <span className="text-basic-orange">24089794727000824</span>{' '}
            telah sampai & segera konfirmasi untuk penerimaan barangnya
          </p>
        </div>
      </div>
      {/* End Item  Notif */}
      {/* Start Item Notif */}
      <div className="flex bg-white px-6 py-4 flex-no-wrap cursor-pointer items-start">
        <div className="flex rounded-full h-12 w-24 bg-basic-orange-16% items-center justify-center">
          <IconChecklist className="h-6 w-6" />
        </div>
        <div className="flex flex-col mx-4 flex-grow">
          <div className="flex w-full justify-between mb-2">
            <h5 className="text-font-gray font-semibold">Pesanan Selesai </h5>
            <p className="text-sm opacity-50 text-font-gray">10:40</p>
          </div>
          <p className="text-sm text-font-gray-light">
            Pesanan <span className="text-basic-orange">24089794727000824</span>{' '}
            sudah diterima, kami tunggu pesanan berikutnya
          </p>
        </div>
      </div>
      {/* End Item  Notif */}
      {/* Start Item Notif */}
      <div className="flex bg-white px-6 py-4 flex-no-wrap cursor-pointer items-start">
        <div className="flex rounded-full h-12 w-24 bg-basic-orange-16% items-center justify-center">
          <IconChecklist className="h-6 w-6" />
        </div>
        <div className="flex flex-col mx-4 flex-grow">
          <div className="flex w-full justify-between mb-2">
            <h5 className="text-font-gray font-semibold">Pesanan Selesai </h5>
            <p className="text-sm opacity-50 text-font-gray">11:00</p>
          </div>
          <p className="text-sm text-font-gray-light">
            Pesanan <span className="text-basic-orange">24089794727000824</span>{' '}
            sudah diterima, kami tunggu pesanan berikutnya
          </p>
        </div>
      </div>
      {/* End Item  Notif */}
    </>
  );
};

export default NotifAll;
